import React from "react";
import { Container } from "reactstrap";
import LoadingSpinner from "../../../../../../toolkit/loadingSpinner";
import styles from "../styles.scss";

const OnboardingDashboardLoader: React.FC = () => (
  <Container className={styles.root}>
    <div style={{ minHeight: "320px", paddingTop: "48px" }}>
      <LoadingSpinner
        title="Loading onboarding"
        message="Please wait while we load your setup progress."
      />
    </div>
  </Container>
);

export default OnboardingDashboardLoader;
